import ConfigSettingsScreen from "components/modules/config-module/ConfigSettingsScreen";
import AccountGroupsScreen from "components/modules/accounts/coa/AccountGroupsScreen";
import LedgerAccountsScreen from "components/modules/accounts/coa/LedgerAccountsScreen";
import VoucherTypesScreen from "components/modules/accounts/voucher/VoucherTypesScreen";
import JournalEntryScreen from "components/modules/accounts/voucher/JournalEntryScreen";
import PaymentVoucherScreen from "components/modules/accounts/voucher/PaymentVoucherScreen";
import ReceiptVoucherScreen from "components/modules/accounts/voucher/ReceiptVoucherScreen";
import EntityAccountingConfigScreen from "components/modules/accounts/config/EntityAccountingConfigScreen";
import PeriodLockScreen from "components/modules/accounts/config/PeriodLockScreen";
import DayBookScreen from "components/modules/accounts/reports/DayBookScreen";
import LedgerStatementScreen from "components/modules/accounts/reports/LedgerStatementScreen";
import TrialBalanceScreen from "components/modules/accounts/reports/TrialBalanceScreen";
import RolePermissionsScreen from "components/modules/settings/RolePermissionsScreen";
import UserAccessScreen from "components/modules/settings/UserAccessScreen";
import OrganisationScreen from "components/modules/settings/OrganisationScreen";
import AccountTypesScreen from "components/modules/accounts/coa/AccountTypesScreen";
import AccountSubtypesScreen from "components/modules/accounts/coa/AccountSubtypesScreen";
import OpenBillReportScreen from "components/modules/accounts/reports/OpenBillReportScreen";
import DebtorsAgeingScreen from "components/modules/accounts/reports/DebtorsAgeingScreen";
import ClientMasterScreen from "components/modules/party/ClientMasterScreen";
import ServiceCategoryScreen from "components/modules/sales/ServiceCategoryScreen";
import CustomerGroupScreen from "components/modules/party/CustomerGroupScreen";
import ArOutstandingScreen from "components/modules/accounts/reports/ArOutstandingScreen";
import ItemSalesScreen from "components/modules/accounts/reports/ItemSalesScreen";
import TaxSummaryScreen from "components/modules/accounts/reports/TaxSummaryScreen";
import RecoverableExpenseScreen from "components/modules/sales/RecoverableExpenseScreen";
import ServiceMasterScreen from "components/modules/sales/ServiceMasterScreen";
import SalesInvoiceScreen from "components/modules/sales/SalesInvoiceScreen";
import CreditNoteScreen from "components/modules/sales/CreditNoteScreen";
import PurchaseInvoiceScreen from "components/modules/purchase/PurchaseInvoiceScreen";
import PurchaseDebitNoteScreen from "components/modules/purchase/PurchaseDebitNoteScreen";
import SupplierSetoffScreen from "components/modules/purchase/SupplierSetoffScreen";
import CustomerSetoffScreen from "components/modules/sales/CustomerSetoffScreen";
// Inventory Core masters (ADR-0058 slice 1, seed 163)
import ItemMasterScreen from "components/modules/inventory/ItemMasterScreen";
import ItemCategoryScreen from "components/modules/inventory/ItemCategoryScreen";
import ItemClassificationScreen from "components/modules/inventory/ItemClassificationScreen";
import UnitOfMeasureScreen from "components/modules/inventory/UnitOfMeasureScreen";
import StockLocationScreen from "components/modules/inventory/StockLocationScreen";
import InventorySettingsScreen from "components/modules/inventory/InventorySettingsScreen";
// Inventory slice 2 (ADR-0058, seed 167)
import OpeningStockScreen from "components/modules/inventory/OpeningStockScreen";
import StockPositionScreen from "components/modules/inventory/StockPositionScreen";
import StockCardScreen from "components/modules/inventory/StockCardScreen";
import ReceiptScreen from "components/modules/banking/ReceiptScreen";
import ReceiptWorksheetScreen from "components/modules/banking/ReceiptWorksheetScreen";
import BankStatementScreen from "components/modules/banking/BankStatementScreen";
import BankReconciliationScreen from "components/modules/banking/BankReconciliationScreen";
import TaxSettingsScreen from "components/modules/tax/TaxSettingsScreen";
import TaxMastersHost from "components/modules/tax/TaxMastersHost";
import TaxClassificationsScreen from "components/modules/tax/TaxClassificationsScreen";
import SetupChecklistScreen from "components/modules/setup/SetupChecklistScreen";

export const COMPONENT_REGISTRY: Record<string, React.ComponentType<any>> = {
  AccountGroupsScreen: AccountGroupsScreen,
  LedgerAccountsScreen: LedgerAccountsScreen,
  VoucherTypesScreen: VoucherTypesScreen,
  JournalEntryScreen: JournalEntryScreen,
  // Two keys, one screen: the live nav resolves by the DB's component_name
  // ('PaymentScreen', seed 127 — immutable), the static fallback map by ours.
  PaymentVoucherScreen: PaymentVoucherScreen,
  PaymentScreen: PaymentVoucherScreen,
  // Receipt Voucher — one-step receipt (ADR-0054, seed 150).
  ReceiptVoucherScreen: ReceiptVoucherScreen,
  EntityAccountingConfigScreen: EntityAccountingConfigScreen,
  PeriodLockScreen: PeriodLockScreen,
  DayBookScreen: DayBookScreen,
  LedgerStatementScreen: LedgerStatementScreen,
  TrialBalanceScreen: TrialBalanceScreen,
  RolePermissionsScreen: RolePermissionsScreen,
  UserAccessScreen: UserAccessScreen,
  OrganisationScreen: OrganisationScreen,
  AccountTypesScreen: AccountTypesScreen,
  AccountSubtypesScreen: AccountSubtypesScreen,
  OpenBillReportScreen: OpenBillReportScreen,
  DebtorsAgeingScreen: DebtorsAgeingScreen,
  ClientMasterScreen: ClientMasterScreen,
  ServiceCategoryScreen: ServiceCategoryScreen,
  CustomerGroupScreen: CustomerGroupScreen,
  ArOutstandingScreen: ArOutstandingScreen,
  ItemSalesScreen: ItemSalesScreen,
  // Tax Summary by Classification — the HSN-wise summary over the snapshots (seed 143, ADR-0047 Phase 2 §8)
  TaxSummaryScreen: TaxSummaryScreen,
  RecoverableExpenseScreen: RecoverableExpenseScreen,
  ServiceMasterScreen: ServiceMasterScreen,
  SalesInvoiceScreen: SalesInvoiceScreen,
  CreditNoteScreen: CreditNoteScreen,
  PurchaseInvoiceScreen: PurchaseInvoiceScreen,
  PurchaseDebitNoteScreen: PurchaseDebitNoteScreen,
  SupplierSetoffScreen: SupplierSetoffScreen,
  CustomerSetoffScreen: CustomerSetoffScreen,
  ItemMasterScreen: ItemMasterScreen,
  ItemCategoryScreen: ItemCategoryScreen,
  ItemClassificationScreen: ItemClassificationScreen,
  UnitOfMeasureScreen: UnitOfMeasureScreen,
  StockLocationScreen: StockLocationScreen,
  InventorySettingsScreen: InventorySettingsScreen,
  OpeningStockScreen: OpeningStockScreen,
  StockPositionScreen: StockPositionScreen,
  StockCardScreen: StockCardScreen,
  ReceiptScreen: ReceiptScreen,
  ReceiptWorksheetScreen: ReceiptWorksheetScreen,
  BankStatementScreen: BankStatementScreen,
  BankReconciliationScreen: BankReconciliationScreen,
  TaxSettingsScreen: TaxSettingsScreen,
  // Host for the relocated shared tax-master module (seed 132 / TaxCore ADR-0019 §8)
  TaxMastersHost: TaxMastersHost,
  // Classification master — HSN / SAC per jurisdiction (seed 140, ADR-0047 Phase 2 §7)
  TaxClassificationsScreen: TaxClassificationsScreen,
  // Setup readiness checklist (seed 144, ADR-0048 §3)
  SetupChecklistScreen: SetupChecklistScreen,
  ConfigSettingsScreen: ConfigSettingsScreen,
};
